module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_5.4f2ff5d7.png";